import React from 'react'
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Chip,
  Grid,
} from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import CardEditor from './CardEditor'

const verticalMenuProps = {
  MenuListProps: {
    sx: {
      '&&': {
        alignItems: 'stretch',
        display: 'flex',
        flexDirection: 'column',
      },
    },
  },
}

const verticalMenuItemSx = {
  '&&': {
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'flex-start',
    textAlign: 'left',
    width: '100%',
  },
}

const useStyles = makeStyles({
  formControl: {
    marginBottom: 20,
    width: '100%',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  gridContainer: {
    marginBottom: 20,
  },
})

const LayoutForm = ({
  layout,
  setLayout,
  addCard,
  deleteCard,
  moveCard,
  addField,
  deleteField,
  moveField,
  industries,
  objectType,
  isDefaultLayout,
}) => {
  const classes = useStyles()

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setLayout({ ...layout, [name]: value })
  }

  const handleIndustryChange = (event) => {
    setLayout({ ...layout, industry_ids: event.target.value })
  }

  if (layout.archived_at === undefined) {
    setLayout({ ...layout, archived_at: null })
  }

  return (
    <div>
      <Grid container spacing={2} className={classes.gridContainer}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Name"
            name="name"
            value={layout.name || ''}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Description"
            name="description"
            value={layout.description || ''}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            variant="outlined"
          />
        </Grid>
      </Grid>
      {!isDefaultLayout && (
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="industry-label">Industries</InputLabel>
          <Select
            labelId="industry-label"
            multiple
            value={layout.industry_ids || []}
            onChange={handleIndustryChange}
            label="Industries"
            MenuProps={verticalMenuProps}
            sx={{ '&& .MuiSelect-select': { textAlign: 'left' } }}
            renderValue={(selected) => (
              <div className={classes.chips}>
                {selected.map((value) => {
                  const industry = industries.find((ind) => ind.id === value)
                  return (
                    <Chip key={value} label={industry ? industry.name : value} className={classes.chip} />
                  )
                })}
              </div>
            )}
          >
            {industries.map((industry) => (
              <MenuItem key={industry.id} value={industry.id} sx={verticalMenuItemSx}>
                <Checkbox checked={layout.industry_ids && layout.industry_ids.indexOf(industry.id) > -1} />
                <ListItemText primary={industry.name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      <CardEditor
        cards={layout.cards || []}
        setLayout={setLayout}
        addCard={addCard}
        deleteCard={deleteCard}
        moveCard={moveCard}
        addField={addField}
        deleteField={deleteField}
        moveField={moveField}
        objectType={objectType}
        isDefaultLayout={isDefaultLayout}
      />
    </div>
  )
}

export default LayoutForm
